import { VIDEO, GET_VIDEO, setVideo } from "./../actions/videoActions";
import { setLoader } from "./../actions/uiActions";
import { setNotification } from "./../actions/notificationActions";
import { takeLatest, put, call } from "redux-saga/effects";
import { db } from "./../../firebase";

function* getVideoURL(action) {
  try {
    yield put(setLoader({ state: true, resource: VIDEO }));
    const ref = db.ref();
    const snap = yield call([ref, ref.once], "value");
    const val = snap.val();
    const value = val ? val["live"] : {};
    yield put(setVideo(value));
    yield put(setLoader({ state: false, resource: VIDEO }));
  } catch (error) {
    yield put(setLoader({ state: false, resource: VIDEO }));
    yield put(setNotification({ message: error.message, resource: VIDEO }));
  }
}

export default function* videoWatcher() {
  yield takeLatest(GET_VIDEO, getVideoURL);
}



// WEBPACK FOOTER //
// ./src/redux/middleware/videoMiddlerware.js